var MenuNavigationFactory = function ($resource, $window, $location) {
    var getGroupMenuApi =
        "/participant-web-services/rest/menu/getGroupNavigationMenu/groupId/:groupId";
    var getAccountMenuApi = "/participant-web-services/rest/menu/getAccountMenuDetails";
    var getGroupMenuParams = {
        groupId: "@groupId"
    };

    var getAccuApi = "/participant-web-services/rest/nonauth/getAccu";

    var getAccuCodesApi = "/participant-web-services/rest/nonauth/accuCodes";

    var getLegacySSOTokenApi =
        "/participant-web-services/rest/sso/retrieveLegSSOToken/indId/:individualId/group/:groupId";
    var getLegacySSOTokenParams = {
        individualId: "@individualId",
        groupId: "@groupId"
    };

    function setLegacySiteBaseUrl() {
        if (iframeUrl === "") {
            return getCurrentDomain();
        } else {
            return iframeUrl;
        }
    }

    function getCurrentDomain() {
        var currentDomain = $location.protocol() + "://" + $location.host();
        if ($window.location.port !== "") {
            currentDomain += ":" + $window.location.port;
        }
        currentDomain += "/";
        return currentDomain;
    }

    var legacySiteBaseURL = setLegacySiteBaseUrl();

    var ssoToLegacyApi = "/authenticateLegacyApp.do";
    var ssoToLegacyChangePlansApi = "/legacyChangePlan.do";
    var ssoToLegacyParams = {
        synctoken: "@synctoken",
        accu: "@accu",
        gaId: "@groupId",
        indId: "@individualId",
        param: "@uniqueVal"
    };

    return {
        getGroupMenu: $resource(__baseApiUrl__ + getGroupMenuApi, getGroupMenuParams, {
            query: {
                method: "GET",
                isArray: true
            }
        }),

        getAccountMenu: $resource(__baseApiUrl__ + getAccountMenuApi, {
            query: {
                method: "GET",
                isArray: true
            }
        }),

        getAccu: $resource(
            __baseApiUrl__ + getAccuApi,
            {},
            {
                query: {
                    method: "GET",
                    isArray: true
                }
            }
        ),

        getAccuCodes: $resource(
            __baseApiUrl__ + getAccuCodesApi,
            {},
            {
                query: {
                    method: "GET",
                    isArray: false,
                    cache: false
                }
            }
        ),

        getLegacySSOToken: $resource(__baseApiUrl__ + getLegacySSOTokenApi, getLegacySSOTokenParams, {
            query: {
                method: "GET",
                isArray: true,
                cache: false
            }
        }),

        ssoToLegacy: $resource(legacySiteBaseURL + ssoToLegacyApi, ssoToLegacyParams, {
            query: {
                method: "GET",
                isArray: false,
                cache: false
            }
        }),
        ssoToLegacyChangeGroup: $resource(
            legacySiteBaseURL + ssoToLegacyChangePlansApi,
            ssoToLegacyParams,
            {
                query: {
                    method: "GET",
                    isArray: false,
                    cache: false
                }
            }
        )
    }; // End of return
};

MenuNavigationFactory.$inject = ["$resource", "$window", "$location"];
export default MenuNavigationFactory;
